import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../utils/NHCore";
import { NHConfirm } from '../../common/NHModal'
import DkgzEditForm from './DkgzEditForm';
import NHContainerFrame from '../../common/NHContainerFrame';

const baseUrlPath = "/ynjt/lstd/dkgz"; //基础路径

/**
 * 抵扣信息查询
 */
class DkgzIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
            },
        }
    }


    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({ formInitData: {} });
        this.setCurrentPageShow('addFlag');
    }
    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let params = formData;
            NHFetch(baseUrlPath + '/insert', 'POST', params)
                .then(res => {
                    if (res) {
                        message.success("新增抵扣项目成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })
        });
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("是否确定删除选中的多条数据？", () => {
                this.handleDelete(selectedRowKeys);
            }, "warn");
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }

    //删除操作
    handleDelete = (pkids) => {
        NHFetch(baseUrlPath + '/deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
    }

    //修改按钮点击事件
    handleUpdateBtnClick = (record) => {
        this.setState({ formInitData: record }, () => {
            this.setCurrentPageShow('updateFlag');
        });
    }

      //修改面板保存方法
      handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            let params = formData;
            NHFetch(baseUrlPath + '/update', 'POST', params)
                .then(res => {
                    if (res) {
                        message.success("修改抵扣项目成功！");//TODO 把此处的信息改成自己的
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })
        });
    }
    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '收费项目',
                dataIndex: 'SFXM',
                width: '50px',
            }, {
                title: '排序号',
                dataIndex: 'PXH',
                width: '50px',
                search: 'input',
            },
        ];
        const action = [
            { title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_fwwgl_ksdh:udpate' },
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_lstd_dkgz"}
                        columns={columnConst}
                        action={action}
                    >
                        {
                            hasAuth('zhxg_yxgl_swbl_lstd:add') ?
                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_swbl_lstd:delete') ?
                                <Button type="danger" ghost style={{ marginLeft: 10 }}
                                    onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }

                    </NHTable>
                </div>
                <NHContainerFrame ref="nhAddModal"
                    title="新增抵扣项目"
                    visible={this.state.frameVisibleMap.addFlag}
                    onOk={this.handleSaveAdd}
                    onCancel={this.handleCloseFrame}
                >
                    <DkgzEditForm ref="nhAddForm" initFormData={this.state.formInitData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhUpdateModal"
                                  title="修改抵扣项目"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  onOk={this.handleSaveUpdate}
                                  onCancel={this.handleCloseFrame}
                >
                    <DkgzEditForm ref="nhUpdateForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
            </div>
        )
    }
}

export default DkgzIndex;



// WEBPACK FOOTER //
// ./components/swbl/lstd/DkgzForm.js